<div class="multi-image-dialog">
    <h2 mat-dialog-title>Select Multiple Images</h2>

    <mat-dialog-content class="dialog-content">
        <!-- Navigation breadcrumbs -->
        <div class="navigation-bar">
            <button mat-button (click)="goBack()" [disabled]="curpath === '/'">
                <mat-icon>arrow_back</mat-icon> Back
            </button>
            <span class="current-path">{{ curpath }}</span>
        </div>

        <!-- Action buttons -->
        <div class="action-bar">
            <button mat-button (click)="deselectAll()" [disabled]="selectedFiles.size === 0">
                <mat-icon>clear</mat-icon> Deselect All
            </button>
            <span class="selected-count">{{ selectedFiles.size }} selected</span>

            <!-- Upload button -->
            <button mat-button (click)="uploaddlg = !uploaddlg" class="upload-btn">
                <mat-icon>cloud_upload</mat-icon> Upload
            </button>
        </div>

        <!-- Upload widget -->
        <div *ngIf="uploaddlg" class="upload-section">
            <app-uploadwidget [path]="'files/' + currentUser?.uid + curpath" (backgroundUploaded)="backgroundUploaded($event)" (uploadFailed)="uploadFailed($event)">
            </app-uploadwidget>
        </div>

        <!-- Files grid view -->
        <div class="files-grid">
            <div class="file-item" *ngFor="let item of dataSource.data" [class.selected]="isFileSelected(item)" [class.folder]="item.typ === 'folder'">

                <!-- Folder item -->
                <div *ngIf="item.typ === 'folder'" class="folder-item" (click)="changeFolder(curpath + item.name + '/')">
                    <mat-icon class="folder-icon">folder</mat-icon>
                    <div class="item-name">{{ item.name }}</div>
                </div>

                <!-- Image file item -->
                <div *ngIf="item.typ === 'file'" class="image-item">
                    <mat-checkbox [checked]="isFileSelected(item)" (change)="toggleFileSelection(item)" class="file-checkbox">
                    </mat-checkbox>

                    <div class="image-preview" (click)="toggleFileSelection(item)">
                        <img [src]="item.url" [alt]="item.name">
                    </div>

                    <div class="item-info">
                        <div class="item-name" [title]="item.name">{{ item.name }}</div>
                        <div class="item-date">{{ item.uploadtime | date:'short' }}</div>

                        <!-- Value input field for selected images -->
                        <div *ngIf="isFileSelected(item)" class="value-input">
                            <mat-form-field appearance="outline" class="value-field">
                                <mat-label>Value</mat-label>
                                <input matInput [ngModel]="getFileValue(item)" (ngModelChange)="setFileValue(item, $event)" placeholder="Enter value..." (click)="$event.stopPropagation()">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Selected images with values panel -->
        <div *ngIf="selectedFiles.size > 0" class="selected-panel">
            <h3>Selected Images & Values</h3>
            <div class="selected-list">
                <div *ngFor="let file of getSelectedFilesArray()" class="selected-item">
                    <img [src]="file.url" [alt]="file.name" class="selected-thumbnail">
                    <div class="selected-info">
                        <div class="selected-name">{{ file.name }}</div>
                        <mat-form-field appearance="outline" class="selected-value-field">
                            <mat-label>Value</mat-label>
                            <input matInput [ngModel]="getFileValue(file)" (ngModelChange)="setFileValue(file, $event)" placeholder="Enter value...">
                        </mat-form-field>
                    </div>
                    <button mat-icon-button (click)="toggleFileSelection(file)" class="remove-btn">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="primary" (click)="onApply()" [disabled]="selectedFiles.size === 0">
            Apply ({{ selectedFiles.size }} selected)
        </button>
    </mat-dialog-actions>
</div>